import React from 'react';
import { DEFAULT_DESIGN, OrderConfirmationDesign } from './design';

const DesignContext =
    React.createContext<OrderConfirmationDesign>(DEFAULT_DESIGN);

export const DesignProvider = DesignContext.Provider;

export const useDesign = (): OrderConfirmationDesign =>
    React.useContext(DesignContext);
